import React, { useState, useEffect } from "react";
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import ButtonLogReg from '../../components/ButtonLogReg';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';

import { useSearchParams } from 'react-router-dom';
import LoadingScreen from "../../components/LoadingScreen";
import NotFound from "../../components/NotFound";
import "../../css/card.css"
import "../../css/search.css"

export default function SearchPage() {
   const [user, setUser] = React.useState({});
   const [isLoading, setIsLoading] = useState(false);
   const TICKET_PER_PAGE = 15;
   const [pageArr, setPageArr] = useState([]);
   const [viewProducts, setViewProducts] = useState([]);
   const [searchParams, setSearchParams] = useSearchParams();
   const [Data, setData] = useState([])
   const [status, setStatus] = useState('');

   let search = window.location.search;
   let params = new URLSearchParams(search);
   let fooCategory = params.get('category');
   let fooProduct = params.get('product');
   const query = search.substring(1, 9)
   const newQuery = query.replace(('?', '='), '')

   React.useEffect(() => {
      const fetchProduct = async (filter) => {
         let url = 'https://w-shop-backend.vercel.app/api/products?';
         if (!!filter) {
            const params = new URLSearchParams();
            for (const [key, value] of Object.entries(filter)) {
               params.set(key, value);
            };
            url += params.toString();
         };
         fetch(url, {
            method: 'GET',
         })
            .then((response) => response.json())
            .then((body) => {
               setIsLoading(true);
               const product = body.data;
               setStatus(body.status)
               product.sort((a, b) => a.id - b.id);
               setData(product);
               setIsLoading(false);
            })
            .catch(error => {
               console.error(error);
               setIsLoading(false);
            });
      }
      document.title = 'W-Shop Search';
      setIsLoading(true);
      if (newQuery === 'category') {
         fetchProduct({ category: fooCategory })
      } else if (newQuery === 'product') {
         fetchProduct({ product: fooProduct })
      }
      setIsLoading(false);
   }, [fooCategory, fooProduct, newQuery])

   useEffect(() => {
      setIsLoading(true)
      if (!searchParams.get('page')) {
         if (Data.length > TICKET_PER_PAGE) {
            setSearchParams({ page: 1 });
         } else {
            setViewProducts(Data);
         }
      } else {
         if (parseInt(searchParams.get('page')) > Math.ceil(Data.length / TICKET_PER_PAGE)) {
            setSearchParams({
               page: 1
            });
         } else {
            const page = searchParams.get('page');
            setViewProducts(Data.slice(TICKET_PER_PAGE * (page - 1), TICKET_PER_PAGE * page));

            const maxPage = Math.ceil(Data.length / TICKET_PER_PAGE);
            const pageList = [];
            const floor = ((page - 4) < 1) ? 1 : (page - 4);
            const ceil = ((4 + parseInt(page)) > maxPage) ? maxPage : (4 + parseInt(page));
            for (let i = floor; i <= ceil; i++) {
               pageList.push(i);
            };
            setPageArr(pageList);
         }
      }
      setIsLoading(false)
   }, [Data, searchParams, setSearchParams]);

   const rupiah = (number) => {
      return new Intl.NumberFormat("id-ID", {
         style: "currency",
         currency: "IDR"
      }).format(number);
   }

   let logReg
   let mB
   let notification
   let trolly
   if (user.role === 'buyer') {
      logReg = <Profile userData={user} />
      mB = ''
      trolly = <Trolly />
      notification = <Notification />
   } else {
      logReg = <ButtonLogReg />
      mB = <a href="/sellerLogin" className="navbar-top">Mulai Berjualan  |</a>
   }
   return (
      <>
         <Navbar logReg={logReg} mb={mB} notification={notification} trolly={trolly} userData={setUser} />
         <div style={{ background: "#F6F6F6" }} className='pb-5'>
            <LoadingScreen active={isLoading} />
            <div className='container pt-5 ' >
               <div className="row" style={{ minHeight: "500px" }}>
                  {
                     status !== 'error' ? (
                        viewProducts.map((items) => (
                           <div className="col" key={items.id}>
                              <a href={'/search/detailSearch/' + items.id} className="card mb-5" style={{ width: "216px", height: "329px", textDecoration: "none" }}
                                 onClick={() => {
                                 }}
                              >
                                 <img src={items.imgUrl} className="card-img-top border-bottom" alt="..." style={{ height: "216px" }} />
                                 <div className="card-body">
                                    <h6 className='cardTitle'>{items.product}</h6>
                                    <h6 className='cardPrice'>{rupiah(items.price)}</h6>
                                    <h6 className='cardProvince'>{items.seller.provinces}</h6>
                                 </div>
                              </a>
                           </div>
                        )))
                        : <NotFound />
                  }
               </div>
               <div className='page-button-list'>
                  {(parseInt(searchParams.get('page')) === 1) ? '' :
                     <>
                        <button
                           className='page-arrow'
                           onClick={() => { setSearchParams({ page: 1 }) }}
                        >
                           <img src='/dbl_left_arrow.svg' alt='to start' />
                        </button>
                        <button
                           className='page-arrow'
                           onClick={() => { setSearchParams({ page: parseInt(searchParams.get('page')) - 1 }) }}
                        >
                           <img src='/left_arrow.svg' alt='to prev' />
                        </button>
                     </>
                  }
                  {pageArr.map((x, i) => {
                     return <button
                        key={`page${i + 1}`}
                        className={(x === parseInt(searchParams.get('page'))) ? 'active' : ''}
                        onClick={(e) => {
                           setSearchParams({
                              page: x
                           })
                        }}
                     >{x}</button>
                  })
                  }
                  {(parseInt(searchParams.get('page')) === Math.ceil(Data.length / TICKET_PER_PAGE)) ? '' :
                     <>
                        <button
                           className='page-arrow'
                           onClick={() => { setSearchParams({ page: parseInt(searchParams.get('page')) + 1 }) }}
                        >
                           <img src='/right_arrow.svg' alt='to prev' />
                        </button>
                        <button
                           className='page-arrow'
                           onClick={() => { setSearchParams({ page: Math.ceil(Data.length / TICKET_PER_PAGE) }) }}
                        >
                           <img src='/dbl_right_arrow.svg' alt='to start' />
                        </button>
                     </>
                  }
               </div>
            </div>
         </div>
         <Footer />
      </>
   );
}
